import { useState, useEffect } from 'react';
import Confetti from 'react-confetti';

const SuccessBookingAnimation = ({ show, onClose }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const [showConfetti, setShowConfetti] = useState(false);

    useEffect(() => {
        if (show) {
            setShowConfetti(true);
            const timer = setTimeout(() => setShowConfetti(false), 5000);
            return () => clearTimeout(timer);
        }
    }, [show]);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (!show) return null;

    return (
        <>
            {showConfetti && (
                <Confetti
                    width={windowSize.width}
                    height={windowSize.height}
                    recycle={false}
                    numberOfPieces={500}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        zIndex: 9999, // 🔥 higher than modal
                        pointerEvents: 'none', // allows clicking modal buttons
                      }}
                />
            )}

            <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-flup-surface p-8 rounded-xl shadow-2xl text-center max-w-md mx-4 relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-r from-yellow-100 to-pink-100 opacity-30"></div>

                    <div className="relative z-10">
                        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <svg
                                className="w-12 h-12 text-green-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>

                        <h2 className="text-3xl font-bold text-flup-ink mb-3">Success!</h2>
                        <p className="text-flup-ink-2 mb-6">
                            Your payment has been confirmed. A confirmation has been sent to your email.
                        </p>

                        <button
                            onClick={onClose}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors shadow-md"
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};


export default SuccessBookingAnimation
// Usage:
// <BookingSuccessModal show={bookingSuccess} onClose={() => setBookingSuccess(false)} />